import React, { useEffect, useState } from 'react'
import axios from 'axios';

const UserAttendees = ({attendees}) => {
  const [registeredCount, setRegisteredCount] = useState(0);
  const [bangladeshiUsers, setBangladeshiUsers] = useState([]);

  console.log("Attendees:", attendees);

  useEffect(() => {
    // বাংলাদেশী ইউজার ডেটা লোড করুন
    const loadBangladeshiUsers = async () => {
      try {
        // বিকল্প 1: রিয়েল বাংলাদেশী ইউজার ডেটা (API)
        const response = await axios.get('https://randomuser.me/api/?results=3&nat=bd');
        setBangladeshiUsers(response.data.results);
        
        // বিকল্প 2: লোকাল ডেটা ব্যবহার
        // setBangladeshiUsers([
        //   { picture: { thumbnail: "/images/bd-user1.jpg" }, name: { first: "রহিম" } },
        //   { picture: { thumbnail: "/images/bd-user2.jpg" }, name: { first: "সুমাইয়া" } },
        //   { picture: { thumbnail: "/images/bd-user3.jpg" }, name: { first: "আরাফাত" } }
        // ]);
      } catch (error) {
        console.error("Error loading Bangladeshi users:", error);
        // ফলব্যাক ডেটা
        setBangladeshiUsers([
          { picture: { thumbnail: "https://i.ibb.co/8XJZJQJ/bd-man1.jpg" }, name: { first: "রহিম" } },
          { picture: { thumbnail: "https://i.ibb.co/4WXYXYX/bd-woman1.jpg" }, name: { first: "সুমাইয়া" } },
          { picture: { thumbnail: "https://i.ibb.co/0JQJQJQ/bd-man2.jpg" }, name: { first: "আরাফাত" } }
        ]);
      }
    };

    loadBangladeshiUsers();

    // রেজিস্ট্রেশন কাউন্ট সিমুলেশন
    const interval = setInterval(() => {
      setRegisteredCount(prev => {
        const randomIncrement = Math.floor(Math.random() * 3) + 1;
        return prev + randomIncrement;
      });
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div className="flex-col md:flex-row items-center justify-center mb-8">
        <div className="flex items-center justify-center -space-x-4 mr-4">
          {bangladeshiUsers.map((user, index) => (
            <img 
              key={index}
              src={user.picture?.thumbnail || user.thumbnail}
              alt={user.name?.first || "Bangladeshi attendee"}
              className="w-10 h-10 rounded-full border-2 border-white"
              title={user.name?.first || ""}
            />
          ))}
        </div>
        
        <div className="mt-2">
          <p className="font-semibold text-gray-800">
            {<span className="bg-gradient-to-r text-lg from-blue-600 to-purple-600 bg-clip-text text-transparent">
              {attendees.attendees}+
            </span>} {attendees.title}
          </p>
          <p className="text-sm text-gray-600">
            {attendees.description}
          </p>
        </div>
      </div>
    </div>
  )
}

export default UserAttendees